import { HttpParams } from "@angular/common/http";
import { BaseApi } from "@edl-development/edl-common";
import { PagedModel } from "src/app/model/base/paged.model";

export abstract class PaetepApi extends BaseApi {
    protected generatePagingParams(pagedModel: PagedModel) {
        let params = new HttpParams()
            .append('offset', String(pagedModel.offset))
            .append('limit', String(pagedModel.limit))
            .append('ascending', String(pagedModel.ascending ?? true))

        if (pagedModel.orderBy) {
            params = params.append('orderBy', this.convertParam(pagedModel.orderBy));
        }

        if (pagedModel.bid) {
            params = params.append('bid', String(pagedModel.bid));
        }

        if (pagedModel.searchBy) {
            params = params.append('searchBy', this.convertParam(pagedModel.searchBy));
        }

        if (pagedModel.type) {
            params = params.append('type', String(pagedModel.type));
        }

        if (pagedModel.status) {
            params = params.append('status', String(pagedModel.status));
        }

        return params;
    }

    /**
     * Appends a value to a set of query params, but only when it's actually present.
     *
     * @param params The params to append to.
     * @param key The query parameter name.
     * @param value The value to append; skipped entirely if null, undefined, or an empty string.
     * @returns The params, with the value appended (as a string, matching every other value in
     * this class) if it was present.
     */
    protected appendIfPresent(params: HttpParams, key: string, value: string | number | boolean | null | undefined): HttpParams {
        return value === null || value === undefined || value === '' ? params : params.append(key, value);
    }
}